import { api } from './api';

export const sfxApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSfxList: builder.query({
      query: (params = {}) => ({
        url: '/admin/sfx',
        params: {
          page: params.page ?? 1,
          limit: params.limit ?? 10,
          ...(params.search && { search: params.search }),
          ...(params.sortBy && { sortBy: params.sortBy }),
          ...(params.sortOrder && { sortOrder: params.sortOrder }),
          ...(params.status !== undefined && params.status !== '' && { status: params.status }),
          ...(params.category_id && { category_id: params.category_id }),
          ...(params.author_id != null &&
            params.author_id !== '' && { author_id: params.author_id }),
          ...(params.needs_metadata === true && { needs_metadata: 'true' }),
        },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'Sfx', id })),
              { type: 'Sfx', id: 'LIST' },
            ]
          : [{ type: 'Sfx', id: 'LIST' }],
    }),
    deleteSfx: builder.mutation({
      query: (id) => ({
        url: `/admin/sfx/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Sfx', id },
        { type: 'Sfx', id: 'LIST' },
      ],
    }),
    deleteSfxBulk: builder.mutation({
      query: (ids) => ({
        url: '/admin/sfx',
        method: 'DELETE',
        body: { ids },
      }),
      invalidatesTags: [{ type: 'Sfx', id: 'LIST' }],
    }),
    regenerateSfxMetadata: builder.mutation({
      query: (id) => ({
        url: `/admin/sfx/${id}/regenerate-metadata`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Sfx', id },
        { type: 'Sfx', id: 'LIST' },
      ],
    }),
    regenerateSfxMetadataBulk: builder.mutation({
      query: (ids) => ({
        url: '/admin/sfx/regenerate-metadata',
        method: 'POST',
        body: { ids },
      }),
      invalidatesTags: [{ type: 'Sfx', id: 'LIST' }],
    }),
    setFeaturedSfx: builder.mutation({
      query: ({ ids, featured }) => ({
        url: '/admin/sfx/set-featured',
        method: 'PATCH',
        body: { ids, featured },
      }),
      invalidatesTags: (result, error, { ids }) => [
        ...(ids || []).map((id) => ({ type: 'Sfx', id })),
        { type: 'Sfx', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetSfxListQuery,
  useDeleteSfxMutation,
  useDeleteSfxBulkMutation,
  useSetFeaturedSfxMutation,
  useRegenerateSfxMetadataMutation,
  useRegenerateSfxMetadataBulkMutation,
} = sfxApi;
